

const customFormats = {
    'phone-rd': /^$|\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/,

}

export default customFormats;